import { format } from 'date-fns'

export function getAutoCloseTime() {
  return 1500;
}

export function delay(ms: number) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export function decimalToHex(decimal: any) {
  return ("0" + decimal.toString(16)).substr(-2);
}

export function sha256Encode(str: any) {
  const encoder = new TextEncoder();
  const data = encoder.encode(str);
  return window.crypto.subtle.digest("SHA-256", data);
}

export function base64Encode(input: any) {
  var str = "";
  var bytes = new Uint8Array(input);
  var len = bytes.byteLength;
  for (var i = 0; i < len; i++) {
    str += String.fromCharCode(bytes[i]);
  }
  return btoa(str)
    .replace(/\+/g, "-")
    .replace(/\//g, "_")
    .replace(/=+$/, "");
}

export function fileToBase64(file: any) {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);

    fileReader.onload = () => {
      resolve(fileReader.result);
    };

    fileReader.onerror = (error) => {
      reject(error);
    };
  });
}

export function getDateFromString(stringDate: string) {

    if (!stringDate) {
        return;
    }
    var date = new Date(stringDate);
    var dateFormatted = format(date, 'dd.MM.yyyy');

    return dateFormatted;
}

export function deepCopy(object: any) {
    return JSON.parse(JSON.stringify(object));
}

export function numberWithThousandSeparator(input: number, amountOfDecimal: number) {
    return input.toFixed(amountOfDecimal).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
}

export function convertUTCDateToLocalDate(date: Date) {
    return new Date(date.getTime() - date.getTimezoneOffset() * 60 * 1000);
}